module.exports = __webpack_public_path__ + "img/mots.dd440445.png";